/* =============================================================================
   assets/bb-menu.js — Bloom-Bloom μενού κινητού «MENU MOTSOM» (ακορντεόν) — 09/10/2026
   -----------------------------------------------------------------------------
   Φορτώνεται από το layout/theme.liquid (defer, μετά το main.js). Desktop: καμία αλλαγή.
   1) Υπότιτλος «x κατηγορίες» κάτω από κάθε γονική κατηγορία. Πριν ζούσε ως inline
      script στο section bb_header_style (sections/header-group.json) και μετρούσε και
      τα «Πίσω» / τίτλο του πάνελ (έγραφε 13 αντί για 11). Τώρα μετράει μόνο υποκατηγορίες.
   2) Ακορντεόν (≤768px): οι υποκατηγορίες ανοίγουν στη θέση τους, κάτω από την κατηγορία
      (το CSS είναι στο assets/bb-header.css — το πάνελ του theme από fixed full-screen
      γίνεται στατικό). Το άνοιγμα/κλείσιμο το κάνει το JS του theme (main.js, main-menu:
      μία κατηγορία ανοιχτή κάθε φορά, ξαναπάτημα = κλείσιμο, πάτημα στο όνομα = toggle
      με link_toggle: mobile). Εδώ μόνο:
      - το «Πίσω» κρύβεται (δεν χρειάζεται πια),
      - ο σύνδεσμος-τίτλος της κατηγορίας (π.χ. /collections/spa-proionta) πάει τελευταίος
        ως «Όλη η κατηγορία» — ή κρύβεται αν υπάρχει ήδη ίδιος σύνδεσμος (Collections →
        «Όλα τα προϊόντα»),
      - αν η ανοιχτή κατηγορία δεν χωράει στην οθόνη, το μενού κυλάει ώστε να φανεί,
      - το focus trap του theme (κλειδωμένο μέσα στο <li>) ανοίγει σε όλο το μενού, για να
        δουλεύει το Tab σε όλες τις κατηγορίες.
   ============================================================================= */
(function () {
  'use strict';
  var mq = window.matchMedia('(max-width: 768.98px)');

  function prep() {
    var lis = document.querySelectorAll('.main-nav > li');
    for (var n = 0; n < lis.length; n++) {
      var li = lis[n];
      var sub = li.querySelector('.child-nav');
      if (!sub || sub.hasAttribute('data-bb-ready')) continue;
      sub.setAttribute('data-bb-ready', '');

      var back = sub.querySelector(':scope > li > .main-nav__item--back');
      if (back) back.parentNode.classList.add('bb-hide');

      var head = sub.querySelector(':scope > li > .main-nav__item-header');
      if (head) {
        var hli = head.parentNode;
        var href = head.getAttribute('href');
        var dup = false;
        var links = sub.querySelectorAll(':scope > li:not(.bb-hide) > a.child-nav__item:not(.main-nav__item-header)');
        for (var i = 0; i < links.length; i++) {
          if (links[i].getAttribute('href') === href) { dup = true; break; }
        }
        if (dup) {
          hli.classList.add('bb-hide');
        } else {
          hli.classList.add('bb-all');
          head.setAttribute('aria-label', 'Όλη η κατηγορία ' + head.textContent.trim());
          head.textContent = 'Όλη η κατηγορία';
          sub.appendChild(hli);
        }
      }

      var lbl = li.querySelector('.main-nav__item--primary');
      if (lbl && !lbl.querySelector('.bb-nav-sub')) {
        var cnt = sub.querySelectorAll(':scope > li:not(.bb-hide):not(.bb-all)').length;
        if (cnt) {
          var sp = document.createElement('span');
          sp.className = 'bb-nav-sub';
          sp.textContent = cnt + (cnt === 1 ? ' κατηγορία' : ' κατηγορίες');
          lbl.appendChild(sp);
        }
      }
    }
  }

  /* Μετά το πάτημα σε κατηγορία (το theme έχει ήδη βάλει .is-open): scroll + focus trap */
  function onTap(e) {
    if (!mq.matches || !e.target.closest) return;
    var row = e.target.closest('.main-nav__item--dropdown > .main-nav__row');
    if (!row) return;
    var li = row.parentNode;
    window.setTimeout(function () {
      if (!li.classList.contains('is-open')) return;
      var mm = li.closest('main-menu');
      if (mm && typeof trapFocus === 'function') {
        var ae = document.activeElement;
        trapFocus(mm, (ae && mm.contains(ae)) ? ae : mm);
      }
      var content = li.closest('.main-menu__content');
      if (!content) return;
      var cr = content.getBoundingClientRect();
      var lr = li.getBoundingClientRect();
      if (lr.top >= cr.top && lr.bottom <= cr.bottom) return;
      var top = content.scrollTop + (lr.top - cr.top) - 6;
      content.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
    }, 40);
  }

  function init() {
    prep();
    document.addEventListener('click', onTap);
    /* Theme editor: το header ξαναγεννιέται όταν αλλάζει setting */
    if (window.Shopify && Shopify.designMode) document.addEventListener('shopify:section:load', prep);
  }

  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', init); } else { init(); }
})();
